import { useReadContract } from "wagmi";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import { DisplayValue, Typography } from "../../../../shared";
import { formatUnits } from "viem";

export const DisplayPegPriceToleranceAbs: React.FC = () => {
  const { data: pegPriceToleranceAbs, ...rest } = useReadContract({
    abi: ArbitrageAbi,
    address: contractAddresses.Arbitrage,
    functionName: "pegPriceToleranceAbs",
  });

  return (
    <div className="flex flex-row gap-2">
      <Typography>Peg Price Tolerance Abs:</Typography>
      <DisplayValue
        viewValue={formatUnits(BigInt(pegPriceToleranceAbs || 0), 8)}
        {...rest}
      />
    </div>
  );
};
